/** Keep aligned with Projects page / ProjectService.PROJECT_NAME_MAX_LENGTH. */
export const AGENT_PROJECT_NAME_MAX_LENGTH = 30;

/** Validates project name for AI Agent create (length matches Projects page). */
export function validateAgentProjectName(name: string): string | null {
  const trimmed = name.trim().replace(/\s+/g, ' ');
  if (!trimmed) return 'Project name is required';
  if (trimmed.length > AGENT_PROJECT_NAME_MAX_LENGTH) {
    return `Project name must be ${AGENT_PROJECT_NAME_MAX_LENGTH} characters or fewer`;
  }
  return null;
}
